$('.check-block input').change(() => {
  $(this)
    .parents('.check-block')
    .toggleClass('checked-state');
});
